<template lang="pug">
    cs-modal(@close="$emit('close')")
        .battle-title {{ $i18n.t('battle.battle_stats_modal_title') }}
        .battle-body(v-if="battleResultStats && battleResultStats.length")
            .battle-stage(v-for="(stage, stageIndex) in battleResultStats")
                .battle-stage-title(@click="openStage(stageIndex)")
                    span {{ $i18n.t('olympiads.olympiads_stageForm_stage') }} {{ stageIndex + 1 }}
                    svg-icon.battle-stage-arrow(
                        :name="stageIndex === openedStageIndex ? 'angle-up' : 'angle-down'",
                        size="large",
                    )
                .battle-stage-game(v-if="stageIndex === openedStageIndex")
                    .game-stats
                        .game-stat(v-for="(game, index) in stage" :key="index")
                            .game-stat__name {{ getGameName(game.exercise.gameExercise) }}
                            .game-stat__info
                                .game-stat__user {{ getResultText(game.exercise) }}
                                .game-stat__opponent {{ getResultText(game.opponentExercise) }}
                    divider(:margin="'0'")
        cs-loader(v-else)
</template>

<script>
    import getType from '../utils/trainer/getType';
    import { mapState } from 'vuex';
    import TrainerUtilities from '../utils/trainer/trainer';

    export default {
        mixins: [getType, TrainerUtilities],
        props: {
            battleResultStats: {
                type: Array,
                default: null,
            },
        },
        data() {
            return {
                openedStageIndex: null,
            };
        },
        methods: {
            openStage(index) {
                this.openedStageIndex = index === this.openedStageIndex ? null : index;
            },
            getResultText(exercise) {
                let result = {
                    score: +exercise.points,
                    time: exercise.executionTime,
                };
                return exercise.userId === this.user.id
                    ? this.$i18n.t('battle.battle_stats', result)
                    : this.$i18n.t('battle.battle_opponentStats', result);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
    };
</script>

<style scoped lang="scss">
    .battle-title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: #333333;
        margin: 30px 30px 0 30px;
    }
    .battle-stage-title {
        cursor: pointer;
        box-sizing: border-box;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: #333333;
        text-align: left;
        height: 70px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 100%;
        background: #f7f7ff;
        border-radius: 10px;
        padding: 0 20px 0 20px;
        align-items: center;
    }
    .battle-stage-arrow {
        color: $hsl-color-blue-56;
        @media screen and (max-width: 360px) {
            display: none;
        }
    }
    .battle-stage {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 30px;
        border: 1px solid #f2f2ff;
        box-sizing: border-box;
        border-radius: 10px;
        @media screen and (max-width: 400px) {
            margin: 15px;
        }
    }
    .battle-stage-game {
        display: flex;
        flex-direction: column;
        padding: 15px;
        &:last-child {
            .divider {
                display: none;
            }
        }
    }
    .game-stat:not(:last-child) {
        margin-bottom: 20px;
    }
    .game-stat__name {
        font-weight: 500;
        margin-bottom: 7px;
        @include media($md) {
            font-size: 18px;
        }
    }
</style>
